// extracted by mini-css-extract-plugin
export default {"section_heading":"SectionHeading_section_heading__enl9D","heading":"SectionHeading_heading__9yTT4","description":"SectionHeading_description__QB-4T"};